import { useEffect } from 'react';
import axios from 'axios';

export const usePageTracking = () => {
  useEffect(() => {
    const trackPageVisit = async () => {
      try {
        const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
        
        // Get referrer and current page
        const referrer = document.referrer || null;
        const pageUrl = window.location.pathname;
        const userAgent = navigator.userAgent;
        
        // Don't track admin pages
        if (pageUrl.startsWith('/admin')) {
          return;
        }
        
        await axios.post(`${BACKEND_URL}/api/analytics/track`, {
          page_url: pageUrl,
          referrer: referrer,
          user_agent: userAgent,
          ip_address: null // Will be set by server if needed
        });
      } catch (error) {
        // Silent fail - don't disrupt user experience
        console.debug('Analytics tracking failed:', error);
      }
    };

    trackPageVisit();
  }, []);
};
